import { z } from 'zod';

export const SiteSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type Site = z.infer<typeof SiteSchema>;
